import { createAsyncThunk } from '@reduxjs/toolkit';
import i18next from 'i18next';

const setContent = createAsyncThunk(
  'banner/set-content',
  async (data: string) => {
    const banner = document.getElementsByClassName('alert-box')[0];

    if (banner) {
      banner.innerHTML = '';

      const bannerClose = document.createElement('a');
      bannerClose.href = '#';
      bannerClose.className = 'close';
      bannerClose.textContent = 'x';

      const bannerContent = document.createElement('span');
      bannerContent.textContent = data;

      bannerClose.onclick = () => {
        banner.style.display = 'none';
        banner.className = 'alert-box';
        bannerContent.textContent = '';
      };

      banner.appendChild(bannerContent);
      banner.appendChild(bannerClose);
    }

    return data;
  },
);

export default setContent;
